export default {
  height: 'auto',
  calcHeight: 'auto',
  tip: false,
  border: true,
  index: true,
  indexLabel: '序号',
  selection: true,
  viewBtn: true,
  columnBtn: false,
  column: [
    {
      label: '工单编号',
      prop: 'wordId',
    },
    {
      label: '工单状态',
      prop: 'complaintSubStatus',
      slot: true,
    },
    {
      label: '当前环节',
      prop: 'complaintParentStatus',
      slot: true,
    },
    {
      label: '登记时间',
      prop: 'createTime',
      type: 'datetime',
    },
    {
      label: '反馈内容',
      prop: 'repairDesc',
      type: 'input',
      overHidden: true,
    },
    {
      label: '回访地区',
      prop: 'roomName',
      type: 'input',
    },
    {
      label: '发生地区',
      prop: 'address',
      type: 'input',
      overHidden: true,
    },
    {
      label: '紧急程度',
      prop: 'isExigency',
      slot: true,
    },
    {
      label: '经办部门',
      prop: 'operatorDept',
      props: {
        label: 'title',
        value: 'value',
      },
      dicUrl: '/api/repair/selectDept',
      type: 'select',
    },
    {
      label: '最后办理时间',
      prop: 'updateTime',
      type: 'datetime',
    },
  ],
};
